module.exports = __webpack_public_path__ + "static/media/icon_sheet_summary.ba050ea2.svg";